import React, { useState, useEffect, useContext, useMemo } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import Header from "../../../layout/Header/Header";
// import Footer from "../../layout/Footer/Footer";
import {
  Button,
  Row,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Label,
  ButtonGroup,
  Col,
  Spinner,
} from "reactstrap";
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import autoTable from "jspdf-autotable";
import ExportJsonExcel from "js-export-excel";
import encode from "nodejs-base64-encode";
import axios from "axios";
import BajaAltaMultiple from "../../BajaAltaMultiple";
import { TableHeader, Pagination, Search } from "../../../DataTable";
import useFullPageLoader from "../../../hooks/useFullPageLoader";
import { v4 as uuidv4 } from "uuid";
import qrcode from "qrcode-js";
import moment from "moment";

function ReporteVentasArticulosAgrupado() {
  const { user } = useContext(AuthContext);
  const URL_ARTICULOS_SURTIDOS = process.env.REACT_APP_URL_ARTICULOS_SURTIDOS;
  const URL_ARTICULOS_DEVOLUCIONES =
    process.env.REACT_APP_URL_ARTICULOS_DEVOLUCIONES; // ✅ NUEVO
  const URL_CLIENTES = process.env.REACT_APP_URL_CLIENTES;
  const URL_MARCAS = process.env.REACT_APP_URL_MARCAS;
  const URL_UNIDADES_NEGOCIO = process.env.REACT_APP_URL_UNIDADES_NEGOCIO;
  const URL_SEND_MAIL_ATT = process.env.REACT_APP_URL_SEND_MAIL_ATT;

  let hoy = new Date();
  let inicio = new Date();
  inicio.setDate(inicio.getDate() - 15);

  let endDate = moment(hoy).format("YYYY-MM-DD");
  let startDate = moment(inicio).format("YYYY-MM-DD");

  const [clientes, setClientes] = useState([]);
  const [selectedCliente, setSelectedCliente] = useState("");

  const [marcas, setMarcas] = useState([]);
  const [selectedMarca, setSelectedMarca] = useState("");

  const [unidadesNegocio, setUnidadesNegocio] = useState([]);
  const [selectedUnidadNegocio, setSelectedUnidadNegocio] = useState("");

  const [totalTotalCantidad, setTotalTotalCantidad] = useState(0);
  const [totalTotalCantidadDev, setTotalTotalCantidadDev] = useState(0); // ✅ NUEVO
  const [totalTotalCantidadVentaReal, setTotalTotalCantidadVentaReal] =
    useState(0); // ✅ NUEVO

  const [totalTotalCantidadEntregado, setTotalTotalCantidadEntregado] =
    useState(0);
  const [totalTotalCantidadPorEntregar, setTotalTotalCantidadPorEntregar] =
    useState(0);
  const [totalTotalDinero, setTotalTotalDinero] = useState(0);
  const [totalTotalDineroBruto, setTotalTotalDineroBruto] = useState(0);

  const [selectedFechaInicio, setSelectedFechaInicio] = useState(startDate);
  const [selectedFechaFin, setSelectedFechaFin] = useState(endDate);

  const [modalMail, setModalMail] = useState(false);
  const toggleMail = () => setModalMail(!modalMail);
  const [mailTo, setMailTo] = useState("");

  const [cargando, setCargando] = useState(true);
  const [fechaModificada, setFechaModificada] = useState(false);

  const [activo, setActivo] = useState("");

  //--- Pagination
  const [comments, setComments] = useState([]);
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  const [sorting, setSorting] = useState({ field: "", order: "" });

  const ITEMS_PER_PAGE = 50;

  const Toast = Swal.mixin({
    toast: true,
    position: "center",
    showConfirmButton: false,
    // timer: 5000,
    timerProgressBar: true,
    didOpen: (toast) => {
      toast.addEventListener("mouseenter", Swal.stopTimer);
      toast.addEventListener("mouseleave", Swal.resumeTimer);
    },
  });

  useEffect(() => {
    if (cargando) {
      Toast.fire({
        html: `<i class="fas fa-hourglass-half custom-spin fa-2x" style="margin-right: 16px;"></i>`,
        title: "Danos unos segundos....",
        customClass: {
          icon: "animated-icon",
        },
      });
    } else {
      Toast.close();
    }
  }, [cargando]);
  
useEffect(() => {
  const cargarInicial = async () => {
    try {
      const headersReq = {
        Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
      };

      setCargando(true);

      const [ventasRes, devolRes, marcasRes, clientesRes, unidadesRes] = await Promise.all([
        axios.get(
          `${URL_ARTICULOS_SURTIDOS}Fechas/${selectedFechaInicio}/${selectedFechaFin}`,
          { headers: headersReq }
        ),
        axios.get(
          `${URL_ARTICULOS_DEVOLUCIONES}Fechas/${selectedFechaInicio}/${selectedFechaFin}`,
          { headers: headersReq }
        ),
        axios.get(URL_MARCAS, { headers: headersReq }),
        axios.get(URL_CLIENTES, { headers: headersReq }),
        axios.get(URL_UNIDADES_NEGOCIO, { headers: headersReq }),
      ]);

      const allVentas = ventasRes?.data ?? [];
      const allDevol = devolRes?.data ?? [];

      const agrupadoValues = buildAgrupadoConDevol(allVentas, allDevol);
      setComments(agrupadoValues);

      setMarcas(marcasRes?.data ?? []);
      setClientes(clientesRes?.data ?? []);
      setUnidadesNegocio(unidadesRes?.data ?? []);
      setFechaModificada(false);
    } catch (err) {
      console.log("Error en carga inicial:", err);
    } finally {
      setCargando(false);
    }
  };

  cargarInicial();
}, []);

  const round2 = (n) =>
    Math.round((Number(n || 0) + Number.EPSILON) * 100) / 100;

  // ✅ Build agrupado con devoluciones (por artículo)
const buildAgrupadoConDevol = (allVentas = [], allDevol = []) => {
  const round2 = (n) => Math.round((Number(n || 0) + Number.EPSILON) * 100) / 100;

  // key para agrupar por artículo + cliente
  const makeKey = (idArticulo, idCliente) => `${String(idArticulo || "")}__${String(idCliente || "")}`;

  // 1) Normaliza ventas
  const arrayTabla = (allVentas ?? [])
    .map((a) => {
      const art = a?.articulos?.[0] || {};
      const cli = a?.clientes?.[0] || {};
      const marca = art?.marcas?.[0] || {};
      const un = art?.unidadesNegocio?.[0] || {};

      return {
        SKU: art?.SKU ?? "",
        clave: art?.clave ?? "",
        costoMX: art?.costoMX ?? "",
        nombre: art?.nombre ?? "",
        marca: marca?.name ?? "",
        idMarca: String(marca?._id ?? ""),
        unidadNegocio: un?.name ?? "",
        idUnidadNegocio: String(un?._id ?? ""),
        cantidad: Number(a?.cantidad ?? 0),
        entregado: Number(a?.entregadoCantidad ?? 0),
        porEntregar: Number(a?.porEntregar ?? 0),
        idArticulo: String(art?._id ?? ""),
        precio: Number(a?.precio ?? 0), // neto
        precioBruto: Number(a?.precioBruto ?? 0), // bruto
        idClientes: String(cli?._id ?? ""),
        clientes: cli?.nombre_comercial ?? "",
      };
    })
    .filter((x) => x && x.idArticulo && x.idClientes);

  // 2) Devoluciones por artículo + cliente
  // devMap[key] = { qty, totalNeto, totalBruto, datos base }
  const devMap = (allDevol ?? []).reduce((acc, d) => {
    const art = d?.articulos?.[0] || {};
    const devol = d?.devoluciones?.[0] || {};
    const cli = devol?.clientes?.[0] || {};
    const marca = art?.marcas?.[0] || {};
    const un = art?.unidadesNegocio?.[0] || {};

    const idArticulo = String(art?._id ?? d?.idArticulo ?? "");
    const idClientes = String(cli?._id ?? d?.idCliente ?? "");
    const clientes = cli?.nombre_comercial ?? "";

    // usa cantidad; si en otro lado ya transformaste a cantidadDevuelta, también soporta eso
    const qty = Number(d?.cantidadDevuelta ?? d?.cantidad ?? 0);
    const precio = Number(d?.precio ?? 0);

    if (!idArticulo || !idClientes || !qty) return acc;

    const key = makeKey(idArticulo, idClientes);

    if (!acc[key]) {
      acc[key] = {
        idArticulo,
        SKU: art?.SKU ?? "",
        clave: art?.clave ?? "",
        costoMX: art?.costoMX ?? "",
        nombre: art?.nombre ?? "",
        marca: marca?.name ?? "",
        idMarca: String(marca?._id ?? ""),
        unidadNegocio: un?.name ?? "",
        idUnidadNegocio: String(un?._id ?? ""),
        idClientes,
        clientes,
        qty: 0,
        totalNeto: 0,
        totalBruto: 0,
      };
    }

    acc[key].qty += qty;
    acc[key].totalNeto += precio * qty;
    // si tu devolución no maneja bruto separado, lo dejamos igual que neto
    acc[key].totalBruto += precio * qty;

    return acc;
  }, {});

  // 3) Agrupar ventas por artículo + cliente
  const agrupado = arrayTabla.reduce((groups, item) => {
    const key = makeKey(item.idArticulo, item.idClientes);

    if (!groups[key]) {
      groups[key] = {
        idArticulo: item.idArticulo,
        SKU: item.SKU,
        clave: item.clave,
        costoMX: item.costoMX,

        nombre: item.nombre,
        marca: item.marca,
        idMarca: item.idMarca,
        unidadNegocio: item.unidadNegocio,
        idUnidadNegocio: item.idUnidadNegocio,
        idClientes: item.idClientes,
        clientes: item.clientes,

        // ventas
        cantidad: 0,
        entregado: 0,
        porEntregar: 0,
        totalPrecioVenta: 0,
        totalPrecioBrutoVenta: 0,

        // devoluciones
        cantidadDevuelta: 0,
        totalDevolNeto: 0,
        totalDevolBruto: 0,
      };
    }

    groups[key].cantidad += Number(item.cantidad || 0);
    groups[key].entregado += Number(item.entregado || 0);
    groups[key].porEntregar += Number(item.porEntregar || 0);

    groups[key].totalPrecioVenta += Number(item.precio || 0) * Number(item.cantidad || 0);
    groups[key].totalPrecioBrutoVenta +=
      Number(item.precioBruto || 0) * Number(item.cantidad || 0);

    return groups;
  }, {});

  // 4) Aplicar devoluciones a cada artículo + cliente
  Object.keys(agrupado).forEach((key) => {
    const dev = devMap[key];
    if (!dev) return;

    agrupado[key].cantidadDevuelta = Number(dev.qty || 0);
    agrupado[key].totalDevolNeto = Number(dev.totalNeto || 0);
    agrupado[key].totalDevolBruto = Number(dev.totalBruto || 0);
  });

  // 5) Devoluciones sin venta
  Object.keys(devMap).forEach((key) => {
    if (agrupado[key]) return;

    const dev = devMap[key];

    agrupado[key] = {
      idArticulo: dev.idArticulo,
      SKU: dev.SKU,
      clave: dev.clave,
      costoMX: dev.costoMX,

      nombre: dev.nombre,
      marca: dev.marca,
      idMarca: dev.idMarca,
      unidadNegocio: dev.unidadNegocio,
      idUnidadNegocio: dev.idUnidadNegocio,
      idClientes: dev.idClientes,
      clientes: dev.clientes,

      cantidad: 0,
      entregado: 0,
      porEntregar: 0,
      totalPrecioVenta: 0,
      totalPrecioBrutoVenta: 0,

      cantidadDevuelta: Number(dev.qty || 0),
      totalDevolNeto: Number(dev.totalNeto || 0),
      totalDevolBruto: Number(dev.totalBruto || 0),
    };
  });

  // 6) Calcular promedios y netos
  const agrupadoValues = Object.values(agrupado).map((item) => {
    const cantVenta = Number(item.cantidad || 0);
    const cantDev = Number(item.cantidadDevuelta || 0);

    const precioPromedio = cantVenta ? Number(item.totalPrecioVenta || 0) / cantVenta : 0;
    const precioPromedioBruto = cantVenta
      ? Number(item.totalPrecioBrutoVenta || 0) / cantVenta
      : 0;

    const precioDev = cantDev ? Number(item.totalDevolNeto || 0) / cantDev : 0;
    const precioDevBruto = cantDev ? Number(item.totalDevolBruto || 0) / cantDev : 0;

    const esSoloDevol = cantVenta === 0 && cantDev > 0;

    const cantidadVentaReal = esSoloDevol ? -cantDev : cantVenta - cantDev;

    const precioNetoUnit = esSoloDevol ? precioDev : precioPromedio;
    const precioBrutoUnit = esSoloDevol ? precioDevBruto : precioPromedioBruto;

    const totalPrecio = precioNetoUnit * cantidadVentaReal;
    const totalPrecioBruto = precioBrutoUnit * cantidadVentaReal;

    return {
      ...item,
      precioPromedio: round2(precioPromedio),
      precioPromedioBruto: round2(precioPromedioBruto),
      precioNetoUnit: round2(precioNetoUnit),
      precioBrutoUnit: round2(precioBrutoUnit),
      cantidadVentaReal,
      totalPrecio: round2(totalPrecio),
      totalPrecioBruto: round2(totalPrecioBruto),
    };
  });

  // 7) Orden para UI
  agrupadoValues.sort((a, b) => {
    const cA = a.clientes || "";
    const cB = b.clientes || "";
    if (cA !== cB) return cA.localeCompare(cB);

    const sA = a.SKU || "";
    const sB = b.SKU || "";
    if (sA !== sB) return sA.localeCompare(sB);

    return (a.nombre || "").localeCompare(b.nombre || "");
  });

  return agrupadoValues;
};


  // =========================
  // BOTÓN ACTUALIZAR (ventas + devoluciones)
  // =========================
async function BuscaInfo() {
  try {
    const headersReq = {
      Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
    };

    if (!selectedFechaInicio || !selectedFechaFin) {
      console.log("Faltan fechas");
      return;
    }

    setCargando(true);
    setComments([]);

    const [ventasRes, devolRes] = await Promise.all([
      axios.get(
        `${URL_ARTICULOS_SURTIDOS}Fechas/${selectedFechaInicio}/${selectedFechaFin}`,
        { headers: headersReq }
      ),
      axios.get(
        `${URL_ARTICULOS_DEVOLUCIONES}Fechas/${selectedFechaInicio}/${selectedFechaFin}`,
        { headers: headersReq }
      ),
    ]);

    const allVentas = ventasRes?.data ?? [];
    const allDevol = devolRes?.data ?? [];

    const agrupadoValues = buildAgrupadoConDevol(allVentas, allDevol);
    setComments(agrupadoValues);
    setFechaModificada(false);
  } catch (err) {
    console.log("Error en BuscaInfo:", err);
  } finally {
    setCargando(false);
  }
}

  function PDFTabla() {
    const data = comments.map((a) => {
      if (
        (selectedMarca == "0" || selectedMarca == "" || selectedMarca == a.idMarca) &&
        (selectedCliente == "0" || selectedCliente == "" || selectedCliente == a.idClientes) &&
        (selectedUnidadNegocio == "0" ||
          selectedUnidadNegocio == "" ||
          selectedUnidadNegocio == a.idUnidadNegocio)
      ) {
        return [
          a.SKU,
          a.clave,
          a.nombre,
          a.marca,
          a.clientes,
          new Intl.NumberFormat("en-US").format(a.cantidad),
          new Intl.NumberFormat("en-US").format(a.cantidadDevuelta),
          new Intl.NumberFormat("en-US").format(a.cantidadVentaReal),
          new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: "USD",
            maximumFractionDigits: 2,
          }).format(a.costoMX),
          new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: "USD",
            maximumFractionDigits: 2,
          }).format(a.precioPromedioBruto),
          new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: "USD",
            maximumFractionDigits: 2,
          }).format(a.precioPromedio),
          new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: "USD",
            maximumFractionDigits: 2,
          }).format(a.totalPrecioBruto),
          new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: "USD",
            maximumFractionDigits: 2,
          }).format(a.totalPrecio),
        ];
      }
      return null;
    });

    const dataPDFLimpia = data.filter((el) => el != null);

    const doc = new jsPDF("landscape");
    var img = new Image();
    img.src = process.env.PUBLIC_URL + "Logo-Lynqro-PDF.png";
    doc.addImage(img, "png", 230, 30, 45, 15);
    var img2 = new Image();
    img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
    doc.addImage(img2, "png", 120, 15, 60, 25);
    doc.text(`Reporte Ventas Articulo Agrupado`, 20, 30);
    doc.text(`${selectedFechaInicio} - ${selectedFechaFin}`, 20, 40);

    doc.autoTable({
      head: [
        [
          "SKU",
          "Clave",
          "Nombre",
          "Marca",
          "Cliente",
          "Cantidad",
          "Devoluciones",
          "Cantidad Real",
          "Costo MX",
          "Precio Promedio Bruto",
          "Precio Promedio Neto",
          "Total Bruto",
          "Total Neto",
        ],
      ],
      body: dataPDFLimpia,
      startY: 45,
    });

    window.open(doc.output("bloburl"), "_blank");
  }

  function excel() {
    // 1) Filtrar por marca/unidad
    let filtered = comments.filter(
      (a) =>
        (selectedMarca === "0" || selectedMarca === "" || selectedMarca === a.idMarca) &&
        (selectedCliente == "0" || selectedCliente == "" || selectedCliente == a.idClientes) &&
        (selectedUnidadNegocio === "0" ||
          selectedUnidadNegocio === "" ||
          selectedUnidadNegocio === a.idUnidadNegocio)
    );

    // 2) Filtro por texto
    if (search && search.trim() !== "") {
      const searchLower = search.toLowerCase();
      filtered = filtered.filter((a) =>
        (a.SKU && a.SKU.toLowerCase().includes(searchLower)) ||
        (a.clave && a.clave.toLowerCase().includes(searchLower)) ||
        (a.nombre && a.nombre.toLowerCase().includes(searchLower)) ||
        (a.marca && a.marca.toLowerCase().includes(searchLower)) ||
        (a.clientes && a.clientes.toLowerCase().includes(searchLower)) ||
        String(a.costoMX || "").includes(searchLower) ||
        String(a.cantidad || "").includes(searchLower) ||
        String(a.cantidadDevuelta || "").includes(searchLower) ||
        String(a.cantidadVentaReal || "").includes(searchLower) ||
        String(a.precioPromedio || "").includes(searchLower) ||
        String(a.precioPromedioBruto || "").includes(searchLower) ||
        String(a.totalPrecio || "").includes(searchLower) ||
        String(a.totalPrecioBruto || "").includes(searchLower)
      );
    }

    // 3) Map
    const dataExcel = filtered.map((a) => ({
      SKU: a.SKU,
      Clave: a.clave,
      Nombre: a.nombre,
      Marca: a.marca,
      Clientes: a.clientes,
      CantidadVendida: a.cantidad,
      Devoluciones: a.cantidadDevuelta,
      CantidadReal: a.cantidadVentaReal,
      CostoMX: Number(Number(a.costoMX || 0).toFixed(2)),
      PrecioPromedioBruto: Number(Number(a.precioPromedioBruto || 0).toFixed(2)),
      PrecioPromedioNeto: Number(Number(a.precioPromedio || 0).toFixed(2)),
      TotalBruto: Number(Number(a.totalPrecioBruto || 0).toFixed(2)),
      TotalNeto: Number(Number(a.totalPrecio || 0).toFixed(2)),
    }));

    // 4) Totales al final
    const totalCant = filtered.reduce((acc, a) => acc + Number(a.cantidad || 0), 0);
    const totalDev = filtered.reduce(
      (acc, a) => acc + Number(a.cantidadDevuelta || 0),
      0
    );
    const totalReal = filtered.reduce(
      (acc, a) => acc + Number(a.cantidadVentaReal || 0),
      0
    );
    const totalBruto = filtered.reduce(
      (acc, a) => acc + Number(a.totalPrecioBruto || 0),
      0
    );
    const totalNeto = filtered.reduce((acc, a) => acc + Number(a.totalPrecio || 0), 0);

    dataExcel.push({
      SKU: "",
      Clave: "",
      Nombre: "",
      Marca: "TOTAL GENERAL",
      Clientes: "",
      CantidadVendida: totalCant,
      Devoluciones: totalDev,
      CantidadReal: totalReal,
        CostoMX: "",
      PrecioPromedioBruto: "",
      PrecioPromedioNeto: "",
      TotalBruto: Number(totalBruto.toFixed(2)),
      TotalNeto: Number(totalNeto.toFixed(2)),
    });

    const option = {
      fileName: "ReporteVentasArticulosAgrupado",
      datas: [
        {
          sheetData: dataExcel,
          sheetName: "ReporteVentasArticulosAgrupado",
          sheetFilter: [
            "SKU",
            "Clave",
            "Nombre",
            "Marca",
            "Clientes",
            "CantidadVendida",
            "Devoluciones",
            "CantidadReal",
            "CostoMX",
            "PrecioPromedioBruto",
            "PrecioPromedioNeto",
            "TotalBruto",
            "TotalNeto",
          ],
          sheetHeader: [
            "SKU",
            "Clave",
            "Nombre",
            "Marca",
            "Clientes",
            "CantidadVendida",
            "Devoluciones",
            "CantidadReal",
            "CostoMX",
            "PrecioPromedioBruto",
            "PrecioPromedioNeto",
            "TotalBruto",
            "TotalNeto",
          ],
        },
      ],
    };

    const toExcel = new ExportJsonExcel(option);
    toExcel.saveExcel();
  }

  function enviaMail() {
    const data = comments.map((a) => {
      if (
        (selectedMarca == "0" || selectedMarca == "" || selectedMarca == a.idMarca) &&
        (selectedCliente == "0" || selectedCliente == "" || selectedCliente == a.idClientes) &&
        (selectedUnidadNegocio == "0" ||
          selectedUnidadNegocio == "" ||
          selectedUnidadNegocio == a.idUnidadNegocio)
      ) {
        return [
          a.SKU,
          a.clave,
          a.nombre,
          a.marca,
          a.clientes,
          new Intl.NumberFormat("en-US").format(a.cantidad),
          new Intl.NumberFormat("en-US").format(a.cantidadDevuelta),
          new Intl.NumberFormat("en-US").format(a.cantidadVentaReal),
          new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: "USD",
            maximumFractionDigits: 2,
          }).format(a.costoMX),
          new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: "USD",
            maximumFractionDigits: 2,
          }).format(a.precioPromedioBruto),
          new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: "USD",
            maximumFractionDigits: 2,
          }).format(a.precioPromedio),
          new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: "USD",
            maximumFractionDigits: 2,
          }).format(a.totalPrecioBruto),
          new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: "USD",
            maximumFractionDigits: 2,
          }).format(a.totalPrecio),
        ];
      }
      return null;
    });

    const dataPDFLimpia = data.filter((el) => el != null);

    const doc = new jsPDF("landscape");
    var img = new Image();
    img.src = process.env.PUBLIC_URL + "Logo-Lynqro-PDF.png";
    doc.addImage(img, "png", 230, 30, 45, 15);
    var img2 = new Image();
    img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
    doc.addImage(img2, "png", 120, 15, 60, 25);
    doc.text(`Reporte Ventas Articulo Agrupado`, 20, 30);
    doc.text(`${selectedFechaInicio} - ${selectedFechaFin}`, 20, 40);

    doc.autoTable({
      head: [
        [
          "SKU",
          "Clave",
          "Nombre",
          "Marca",
          "Clientes",
          "Cantidad",
          "Devoluciones",
          "Cantidad Real",
          "Costo MX",
          "Precio Promedio Bruto",
          "Precio Promedio Neto",
          "Total Bruto",
          "Total Neto",
        ],
      ],
      body: dataPDFLimpia,
      startY: 45,
    });

    var att = doc.output("arraybuffer");
    var base64File = encode.encode(att, "base64");

    axios
      .post(
        URL_SEND_MAIL_ATT,
        {
          subject: "Reporte Ventas Articulo Agrupado",
          email: mailTo,
          fileName: "ReporteVentasArticulosAgrupado.pdf",
          att: base64File,
          text: `<table border="0" cellpadding="0" cellspacing="0" width="100%">
         <th><img width="${process.env.REACT_APP_TAMANO_LOGO_MAIL}" align="center" src="${process.env.REACT_APP_LINK_SISTEMA}logoInstitucion.png" /></th>
         <tr align="center" style="font-size:30px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>${process.env.REACT_APP_NOMBRE_INSTITUCION}</tr>
         <tbody>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Hola,</tr>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Adjunto encontraras el Reporte Ventas Articulo Agrupado.</tr>
         </tbody>
         <tr style="font-size:16px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px"><br>Favor de no responder este correo, para cualquier duda favor de comunicarse al ${process.env.REACT_APP_TELEFONO_INSTITUCION}</tr>
         <tr align="right"><br>Powered by <a href="https://lynqro.com"> <img width="20%" align="center" src="${process.env.REACT_APP_LINK_SISTEMA}Logo-Lynqro-PDF.png" /> </a> </tr>
         </table>`,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then(() => {
        toggleMail();
        Swal.fire("Good job!", "Enviado con exito", "success");
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response.data}`,
        });
        console.log(error);
      });
  }

  const headers = [
    { name: "SKU", field: "SKU", sortable: true },
    { name: "Clave", field: "clave", sortable: true },
    { name: "Nombre", field: "nombre", sortable: true },
    { name: "Marca", field: "marca", sortable: true },
    { name: "Clientes", field: "clientes", sortable: true },
    { name: "Cantidad Vendida", field: "cantidad", sortable: true },
    { name: "Devoluciones", field: "cantidadDevuelta", sortable: true }, // ✅ NUEVO
    { name: "Cantidad Real", field: "cantidadVentaReal", sortable: true }, // ✅ NUEVO
    { name: "Costo", field: "costoMX", sortable: true }, // ✅ NUEVO
    { name: "Precio Promedio Bruto", field: "precioPromedioBruto", sortable: true },
    { name: "Precio Promedio Neto", field: "precioPromedio", sortable: true },
    { name: "Total Bruto", field: "totalPrecioBruto", sortable: true },
    { name: "Total Neto", field: "totalPrecio", sortable: true },
  ];

  const commentsData = useMemo(() => {
    let computedComments = comments;

    if (search) {
      computedComments = computedComments.filter(
        (comment) =>
          (comment.SKU || "").toLowerCase().includes(search.toLowerCase()) ||
          (comment.clave || "").toLowerCase().includes(search.toLowerCase()) ||
          (comment.nombre || "").toLowerCase().includes(search.toLowerCase()) ||
          (comment.marca || "").toLowerCase().includes(search.toLowerCase()) ||
          (comment.clientes || "")
            .toLowerCase()
            .includes(search.toLowerCase()) ||
          String(comment.costoMX || "").includes(search) ||
          String(comment.cantidad || "").includes(search) ||
          String(comment.cantidadDevuelta || "").includes(search) ||
          String(comment.cantidadVentaReal || "").includes(search) ||
          String(comment.precioPromedio || "").includes(search) ||
          String(comment.precioPromedioBruto || "").includes(search) ||
          String(comment.totalPrecioBruto || "").includes(search) ||
          String(comment.totalPrecio || "").includes(search),
      );
    }

    if (selectedMarca && selectedMarca !== "0") {
      computedComments = computedComments.filter((e) =>
        String(e.idMarca || "").includes(selectedMarca),
      );
    }

    if (selectedCliente && selectedCliente !== "0") {
      computedComments = computedComments.filter((e) =>
        String(e.idClientes || "").includes(selectedCliente),
      );
    }
    if (selectedUnidadNegocio && selectedUnidadNegocio !== "0") {
      computedComments = computedComments.filter((e) =>
        String(e.idUnidadNegocio || "").includes(selectedUnidadNegocio),
      );
    }

    setTotalItems(computedComments.length);

    const sum = (arr) => arr.reduce((t, v) => t + Number(v || 0), 0);

    setTotalTotalCantidad(sum(computedComments.map((c) => c.cantidad)));
    setTotalTotalCantidadDev(
      sum(computedComments.map((c) => c.cantidadDevuelta)),
    );
    setTotalTotalCantidadVentaReal(
      sum(computedComments.map((c) => c.cantidadVentaReal)),
    );

    setTotalTotalCantidadEntregado(
      sum(computedComments.map((c) => c.entregado)),
    );
    setTotalTotalCantidadPorEntregar(
      sum(computedComments.map((c) => c.porEntregar)),
    );

    setTotalTotalDinero(sum(computedComments.map((c) => c.totalPrecio)));
    setTotalTotalDineroBruto(
      sum(computedComments.map((c) => c.totalPrecioBruto)),
    );

    // Sorting
    if (
      sorting.field &&
      sorting.field != "cantidad" &&
      sorting.field != "cantidadDevuelta" &&
      sorting.field != "cantidadVentaReal" &&
      sorting.field != "precioPromedio" &&
      sorting.field != "precioPromedioBruto" &&
      sorting.field != "totalPrecioBruto" &&
      sorting.field != "totalPrecio"
    ) {
      const reversed = sorting.order === "asc" ? 1 : -1;
      computedComments = computedComments.sort(
        (a, b) =>
          reversed *
          String(a[sorting.field] || "").localeCompare(
            String(b[sorting.field] || ""),
          ),
      );
    }

    if (
      sorting.field &&
      (sorting.field == "cantidad" ||
        sorting.field == "cantidadDevuelta" ||
        sorting.field == "cantidadVentaReal" ||
        sorting.field == "precioPromedio" ||
        sorting.field == "precioPromedioBruto" ||
        sorting.field == "totalPrecioBruto" ||
        sorting.field == "totalPrecio")
    ) {
      const reversed = sorting.order === "asc" ? 1 : -1;
      computedComments = computedComments.sort(
        (a, b) =>
          reversed *
          (parseFloat(a[sorting.field]) - parseFloat(b[sorting.field])),
      );
    }

    return computedComments.slice(
      (currentPage - 1) * ITEMS_PER_PAGE,
      currentPage * ITEMS_PER_PAGE,
    );
  }, [
    comments,
    currentPage,
    search,
    sorting,
    selectedMarca,
    selectedCliente,
    selectedUnidadNegocio,
  ]);

  return (
  <>
    <Header />
      <br />
      <br />

    <div className="card col-12">
      {/* Top buttons */}
      <Row>
        <Col md={8}>
          <Button
            size="sm"
            href="/MenuVentas"
            className="btn btn-danger"
            id="botonListado"
          >
            Regresar
          </Button>
        </Col>

        <Col sm={4}>
          <ButtonGroup id="logoutBoton">
            <Button size="sm" className="btn" color="danger" onClick={PDFTabla}>
              PDF <i className="far fa-file-pdf"></i>
            </Button>

            <Button size="sm" className="btn" onClick={toggleMail} color="info">
              eMail <i className="fas fa-at"></i>
            </Button>

            <Button size="sm" className="btn" color="primary" onClick={excel}>
              Excel <i className="far fa-file-excel"></i>
            </Button>
          </ButtonGroup>
        </Col>
      </Row>

      {/* Modal mail (TU modal chico) */}
      <Modal size="sm" isOpen={modalMail} toggle={toggleMail}>
        <ModalHeader toggle={toggleMail}>
          <h4>Enviar Reporte Ventas Articulo</h4>
        </ModalHeader>
        <ModalBody>
          <Label className="mr-sm-2">Email</Label>
          <Input
            className="col-sm-12"
            type="text"
            value={mailTo}
            required
            onChange={(e) => setMailTo(e.target.value)}
          />
        </ModalBody>
        <ModalFooter>
          <Button size="sm" color="success" onClick={enviaMail}>
            Enviar
          </Button>
        </ModalFooter>
      </Modal>

      <h3 align="center">Reporte Ventas Articulo Agrupado</h3>

      {/* Pagination + Search (arriba) */}
      <div className="row">
        <div className="col-md-8">
          <Pagination
            total={totalItems}
            itemsPerPage={ITEMS_PER_PAGE}
            currentPage={currentPage}
            onPageChange={(page) => setCurrentPage(page)}
          />
        </div>
        <div className="col-md-4 d-flex flex-row-reverse">
          <Search
            onSearch={(value) => {
              setSearch(value);
              setCurrentPage(1);
            }}
          />
        </div>
      </div>

      {/* Filtros */}
      <Row>
        <Col md={2}>
          <Label className="mr-sm-2">Fecha Inicio</Label>
          <Input
            bsSize="sm"
            type="date"
            value={selectedFechaInicio}
            required
            onChange={(e) => {
              setSelectedFechaInicio(e.target.value);
              setFechaModificada(true);
            }}
          />
        </Col>

        <Col md={2}>
          <Label className="mr-sm-2">Fecha Fin</Label>
          <Input
            bsSize="sm"
            type="date"
            value={selectedFechaFin}
            required
            onChange={(e) => {
              setSelectedFechaFin(e.target.value);
              setFechaModificada(true);
            }}
          />
        </Col>

        <Col md={1}>
          <h4></h4>
          <Button
            size="sm"
            className="btn"
            id="botonListado"
            onClick={BuscaInfo}
            color={fechaModificada ? "danger" : "info"}
          >
            Actualizar
          </Button>
        </Col>

        {/* <Col md={2}>
          <Label>Clientes</Label>
          <Input
            bsSize="sm"
            type="select"
            value={selectedCliente}
            onChange={(e) => {
              setSelectedCliente(e.target.value);
              setCurrentPage(1);
            }}
          >
            <option value="0">Selecciona</option>
            {clientes
              .sort((a, b) =>
                a.nombre_comercial > b.nombre_comercial ? 1 : -1
              )
              .map((a) => (
                <option key={a._id} value={a._id}>
                  {a.nombre_comercial}
                </option>
              ))}
          </Input>
        </Col> */}

        <Col md={2}>
          <Label>Marcas</Label>
          <Input
            bsSize="sm"
            type="select"
            value={selectedMarca}
            onChange={(e) => {
              setSelectedMarca(e.target.value);
              setCurrentPage(1);
            }}
          >
            <option value="0">Selecciona</option>
            {marcas
              .sort((a, b) => (a.name > b.name ? 1 : -1))
              .map((a) => (
                <option key={a._id} value={a._id}>
                  {a.name}
                </option>
              ))}
          </Input>
        </Col>

        <Col md={2}>
          <Label>Clientes</Label>
          <Input
            bsSize="sm"
            type="select"
            value={selectedCliente}
            onChange={(e) => {
              setSelectedCliente(e.target.value);
              setCurrentPage(1);
            }}
          >
            <option value="0">Selecciona</option>
            {clientes
              .sort((a, b) => (a.nombre_comercial > b.nombre_comercial ? 1 : -1))
              .map((a) => (
                <option key={a._id} value={a._id}>
                  {a.nombre_comercial}
                </option>
              ))}
          </Input>
        </Col>

        {/* <Col md={2}>
          <Label>Unidad Negocio</Label>
          <Input
            bsSize="sm"
            type="select"
            value={selectedUnidadNegocio}
            onChange={(e) => {
              setSelectedUnidadNegocio(e.target.value);
              setCurrentPage(1);
            }}
          >
            <option value="0">Selecciona</option>
            {unidadesNegocio
              .sort((a, b) => (a.name > b.name ? 1 : -1))
              .map((a) => (
                <option key={a._id} value={a._id}>
                  {a.name}
                </option>
              ))}
          </Input>
        </Col> */}
      </Row>

      <br />

      {/* Tabla */}
      <div className="table-wrapper">
        <Table size="sm" striped borderless className="table-responsive-xl">
          <TableHeader
            headers={headers}
            onSorting={(field, order) => setSorting({ field, order })}
          />
          <tbody>
            {commentsData.map((a, idx) => (
              <tr key={idx}>
                <td>{a.SKU}</td>
                <td>{a.clave}</td>
                <td>{a.nombre}</td>
                <td>{a.marca}</td>
                <td>{a.clientes}</td>
                <td>{new Intl.NumberFormat("en-US").format(a.cantidad)}</td>
                <td>{new Intl.NumberFormat("en-US").format(a.cantidadDevuelta)}</td>
                <td>{new Intl.NumberFormat("en-US").format(a.cantidadVentaReal)}</td>
                <td>
                  {new Intl.NumberFormat("en-US", {
                    style: "currency",
                    currency: "USD",
                    maximumFractionDigits: 2,
                  }).format(a.costoMX)}
                </td>
                <td>
                  {new Intl.NumberFormat("en-US", {
                    style: "currency",
                    currency: "USD",
                    maximumFractionDigits: 2,
                  }).format(a.precioPromedioBruto)}
                </td>
                <td>
                  {new Intl.NumberFormat("en-US", {
                    style: "currency",
                    currency: "USD",
                    maximumFractionDigits: 2,
                  }).format(a.precioPromedio)}
                </td>
                <td>
                  {new Intl.NumberFormat("en-US", {
                    style: "currency",
                    currency: "USD",
                    maximumFractionDigits: 2,
                  }).format(a.totalPrecioBruto)}
                </td>
                <td>
                  {new Intl.NumberFormat("en-US", {
                    style: "currency",
                    currency: "USD",
                    maximumFractionDigits: 2,
                  }).format(a.totalPrecio)}
                </td>
              </tr>
            ))}

            {/* Totales */}
            <tr>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td className="negrita">TOTAL</td>
              <td className="negrita">
                {new Intl.NumberFormat("en-US").format(totalTotalCantidad)}
              </td>
              <td className="negrita">
                {new Intl.NumberFormat("en-US").format(totalTotalCantidadDev)}
              </td>
              <td className="negrita">
                {new Intl.NumberFormat("en-US").format(totalTotalCantidadVentaReal)}
              </td>
              <td></td>
              <td></td>
              <td></td>
              <td className="negrita">
                {new Intl.NumberFormat("en-US", {
                  style: "currency",
                  currency: "USD",
                  maximumFractionDigits: 2,
                }).format(totalTotalDineroBruto)}
              </td>
              <td className="negrita">
                {new Intl.NumberFormat("en-US", {
                  style: "currency",
                  currency: "USD",
                  maximumFractionDigits: 2,
                }).format(totalTotalDinero)}
              </td>
            </tr>
          </tbody>
        </Table>

        {/* Pagination abajo */}
        <div className="col-md-6">
          <Pagination
            total={totalItems}
            itemsPerPage={ITEMS_PER_PAGE}
            currentPage={currentPage}
            onPageChange={(page) => setCurrentPage(page)}
          />
        </div>
      </div>

      <br />
      {loader}
    </div>
  </>
);

}

export default ReporteVentasArticulosAgrupado;
